const scope = "city/";

export const fetch_paginated_cities_saga = `${scope}fetch_paginated_cities`;
export const fetch_city_by_id_saga = `${scope}fetch_city_by_id`;
export const create_new_city_saga = `${scope}fetch_create_new_city`;
export const create_cities_saga = `${scope}create_cities_saga`;
export const update_city_saga = `${scope}update_new_city_saga`;
export const delete_city_saga = `${scope}delete_city_saga`;
